export default __webpack_public_path__ + "static/media/banner4.027af186.jpg";